import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export const container = css`
  max-width: ${pxToRem(700)};
  margin: 2rem auto;

  ${mediaQuery(
    { max: minBreakpoints.M },
    css`
      margin: 2rem;
    `,
  )}
`;
